import { render, staticRenderFns } from "./InvoiceBrowser.vue?vue&type=template&id=2a4a765a&scoped=true&"
import script from "./InvoiceBrowser.vue?vue&type=script&lang=ts&"
export * from "./InvoiceBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceBrowser.vue?vue&type=style&index=0&id=2a4a765a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a765a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VIcon,VTooltip})
